import { createFileRoute } from "@tanstack/react-router";
import GodInvoice from "../../app/views/invoice/godInvoice";

export const Route = createFileRoute("/invoice/invoiceGod")({
  component: GodInvoice,
});
